module.exports = __webpack_public_path__ + "send-twitter.5c6d6958.jpg";